import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { getPageById } from "../services/api/pageApi"; // ✅ use your API file

export default function CookiePolicy() {
  const [page, setPage] = useState(null);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const data = await getPageById(4); // ✅ API call
        setPage(data);
      } catch (err) {
        console.error("API error:", err);
      }
    };

    fetchPage();
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start", // ✅ top align
        pt: 8,
        bgcolor: "#f0f0f0",
        p: 2,
      }}
    >
      {page ? (
        <Box maxWidth={800} width="100%" textAlign="center">
          {/* TITLE */}
          <Typography variant="h4" fontWeight={700}>
            {page.title}
          </Typography>

          {/* CONTENT */}
          <Typography
            variant="body1"
            mt={4}
            textAlign="left" // ✅ better readability
            dangerouslySetInnerHTML={{ __html: page.content }}
          />
        </Box>
      ) : (
        <Typography>Loading...</Typography>
      )}
    </Box>
  );
}